import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import ContentLayout from "studio-edifique/components/ContentLayout";
import { servicePages, services } from "studio-edifique/siteContent";

function ServicesPage() {
  return (
    <ContentLayout
      title="Serviços de arquitetura e engenharia em Itatiba"
      description="Conheça os serviços do Studio Edifique em Itatiba: projeto arquitetônico, interiores, administração de obras e laudos técnicos."
      intro="Encontre o escopo que faz sentido para o seu imóvel ou sua obra. Projeto, acompanhamento e análise técnica podem ser contratados conforme a necessidade de cada cliente."
      eyebrow="Itatiba e região"
    >
      <Grid container spacing={3}>
        {servicePages.map((service) => (
          <Grid item xs={12} md={6} key={service.slug}>
            <Card sx={{ p: 4, height: "100%", display: "flex", alignItems: "flex-start" }}>
              <MKTypography variant="h4" component="h2" mb={2}>
                {service.name}
              </MKTypography>
              <MKTypography variant="body2" color="text" mb={3}>
                {service.intro}
              </MKTypography>
              <MKButton
                component={Link}
                to={`/servicos/${service.slug}`}
                variant="outlined"
                color="info"
                sx={{ mt: "auto" }}
              >
                Conhecer o serviço
              </MKButton>
            </Card>
          </Grid>
        ))}
      </Grid>
      <MKBox component="section" mt={7}>
        <MKTypography variant="h3" component="h2" mb={3}>
          Outras demandas de projeto e obra
        </MKTypography>
        {services
          .filter((service) => !service.path)
          .map((service) => (
            <MKBox key={service.title} mb={3}>
              <MKTypography variant="h5" component="h3">
                {service.title}
              </MKTypography>
              <MKTypography variant="body2" color="text" mt={1}>
                {service.description}
              </MKTypography>
            </MKBox>
          ))}
        <MKTypography component={Link} to="/contato" color="info" variant="button">
          Converse com a equipe para definir o escopo →
        </MKTypography>
      </MKBox>
    </ContentLayout>
  );
}
export default ServicesPage;
